import React from "react";
import $ from 'jquery';
import { withTranslation } from 'react-i18next'
import { scrollToTop } from "../../JS/scrollToTop";
import { connect } from "react-redux";
import { WEB_VERSION_ENABLED } from "../../config/constant";


const LaunchGuide = (props) => {
    const { t } = props
    const room = localStorage.getItem("room")
    $("body").addClass("overlay-cast");
    $("body").removeClass("overlay-click");


    React.useEffect(() => {

        scrollToTop();

        return () => {
            $("body").removeClass("overlay-cast");
        }
    },[])

    return (
        <>
            <section className="overlay help">
                <div onClick={() => props.closeLaunchGuide()} className="overlay-window-container">
                    <div className="intro-help">
                        { !room ? t('guide.launchGuide.logInBefore.show') && <div className="help-bubble help-login">
                            <div className="desc">{t('guide.launchGuide.logInBefore.message')}</div>
                            <div className="icon"></div>
                        </div> : 
                        t('guide.launchGuide.logInAfter.show') && 
                        <div className="help-bubble help-login">
                            <div className="desc">{t('guide.launchGuide.logInAfter.message')}</div>
                            <div className="icon"></div>
                        </div> 
                        }

                        {!room || room == "null" ?
                        props.checkPreCheckInWidgetState == "pre check-in" ?
                        t('guide.launchGuide.pre_checkIn.show') && <div className="help-bubble help-checkin">
                            <div className="desc">{t('guide.launchGuide.pre_checkIn.message')}</div>
                            <div className="icon"></div>
                        </div> 

                        : props.checkPreCheckInWidgetState == "early check-in" ?

                        t('guide.launchGuide.early_checkIn.show') && <div className="help-bubble help-checkin">
                            <div className="desc">{t('guide.launchGuide.early_checkIn.message')}</div>
                            <div className="icon"></div>
                        </div> 

                        : t('guide.launchGuide.checkIn.show') && <div className="help-bubble help-checkin">
                            <div className="desc">{t('guide.launchGuide.checkIn.message')}</div>
                            <div className="icon"></div>
                        </div> : null }

                        { t('guide.launchGuide.doorkey.show') && <div className="help-bubble help-door">
                            <div className="desc">{WEB_VERSION_ENABLED ? t('guide.launchGuide.doorkey.messageWeb') : t('guide.launchGuide.doorkey.message')}</div>
                            <div className="icon"></div>
                        </div>}

                        {
                            t('guide.launchGuide.chat.show') && <div className="help-bubble help-chat" onClick={(e)=>{e.stopPropagation();}}>
                                {t('guide.launchGuide.chat.showImage') && <div className="image" ><img src={t('guide.launchGuide.chat.imagesrc')}/></div>}

                                <div className="desc" >
                                         {t('guide.launchGuide.chat.showDescHeader') && <div className="descHeader" ></div>}
                                         <div className="desc-main-content" dangerouslySetInnerHTML={{__html:t('guide.launchGuide.chat.message')}} ></div>
                                         {t('guide.launchGuide.chat.showDescFooter') && <div className="descFooter" >
                                                    <img src={t('guide.launchGuide.chat.imageDescFootersrc')}/> 
                                            </div>}

                                            { t('guide.launchGuide.chat.showButton')&& <button class="button primary help-chat-button" onClick={() => props.closeLaunchGuide()}>
                                        { t('guide.launchGuide.chat.buttonText')}
                                        </button>
                                            }

                                </div>
                                       
                            </div>
                        }

                        <div className="help-close">
                            {t('guide.launchGuide.close')}
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

const mapStateToProps = state => {
    return {
        checkPreCheckInWidgetState: state.store2.checkPreCheckInWidgetState,
    }
}

export default connect(mapStateToProps, {})(withTranslation('translations')(LaunchGuide));